import AssignTripDetail from "./AssignTripDetail";

export default AssignTripDetail;
